<template>
  <div class="rating-field-response">
    <div class="field-header">
      <h3 class="field-label">
        {{ field.label }}
        <span v-if="field.required" class="required-indicator">*</span>
      </h3>
    </div>

    <div v-if="field.description" class="field-description">
      {{ field.description }}
    </div>

    <div class="rating-container">
      <v-rating
        v-model="localResponse.numericValue"
        :length="maxRating"
        :readonly="disabled"
        color="amber"
        background-color="grey"
        hover
        large
        @input="updateResponse"
      ></v-rating>

      <div class="rating-labels">
        <span class="min-label">{{ minLabel }}</span>
        <span class="max-label">{{ maxLabel }}</span>
      </div>
    </div>

    <div class="rating-value">
      <span class="rating-value-text">Selected Rating: {{ localResponse.numericValue || 'None' }}</span>
    </div>

    <v-textarea
      v-model="localResponse.comment"
      :readonly="disabled"
      outlined
      dense
      label="Comment (Optional)"
      placeholder="Provide a justification for your rating..."
      rows="2"
      auto-grow
      @change="updateResponse"
    ></v-textarea>
  </div>
</template>

<script>
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Field } from '@/shared/types/aperTemplate';
import { ResponseDTO } from '@/shared/apis/aper/aperEvaluations';

@Component
export default class RatingFieldResponse extends Vue {
  @Prop({ type: Object, required: true }) field;
  @Prop({ type: Object, required: false }) response;
  @Prop({ type: Boolean, required: false }) disabled;

  localResponse = {
    fieldId: 0,
    numericValue: undefined,
    comment: ''
  };

  created() {
    this.initializeResponse();
  }

  @Watch('response')
  onResponseChange() {
    this.initializeResponse();
  }

  initializeResponse() {
    if (this.response) {
      this.localResponse = { ...this.response };
    } else {
      this.localResponse = {
        fieldId: this.field.id || 0,
        numericValue: undefined,
        comment: ''
      };
    }
  }

  get minRating() {
    return this.field.minRating !== undefined ? this.field.minRating : 1;
  }

  get maxRating() {
    return this.field.maxRating !== undefined ? this.field.maxRating : 5;
  }

  get minLabel() {
    return this.field.options && this.field.options.length > 0 && this.field.options[0].label
      ? this.field.options[0].label
      : 'Poor';
  }

  get maxLabel() {
    return this.field.options && this.field.options.length > 0 && this.field.options[this.field.options.length - 1].label
      ? this.field.options[this.field.options.length - 1].label
      : 'Excellent';
  }

  updateResponse() {
    this.$emit('update:response', this.localResponse);
  }
}
</script>

<style scoped>
.rating-field-response {
  width: 100%;
}

.field-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.field-label {
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  margin: 0 0 4px 0;
}

.required-indicator {
  color: #f44336;
  margin-left: 4px;
}

.field-description {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 12px;
}

.rating-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 16px;
}

.rating-labels {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 8px;
}

.min-label, .max-label {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.7);
}

.rating-value {
  text-align: center;
  margin-bottom: 16px;
}

.rating-value-text {
  font-size: 0.9rem;
  font-weight: 500;
  color: #3f51b5;
}
</style>
